import { Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-common';
import { ICvxClaimsPrincipal } from '@cvx/cal';
import { CalAngularService } from '@cvx/cal-angular';
import { BehaviorSubject, lastValueFrom, map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AppConfig } from '../services/app-config.service';
import { commonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class CalService {
  public logout() {
    this.cal.userInitiatedSignOut();
    this.router.navigate(['dashboard']);
  }

  private cal: CalAngularService;
  public userSubject: BehaviorSubject<ICvxClaimsPrincipal> = new BehaviorSubject({} as ICvxClaimsPrincipal);
  private isLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(authService: CalAngularService, private commonService: commonService, private router: Router) {
    this.cal = authService;
  }

  async updateAccessToken(): Promise<string> {
    const graphScopes = AppConfig.settings.graphScopes.slice(0);
    graphScopes.unshift(`${AppConfig.settings.clientId}/user_impersonation`);
    const token: Promise<string> = this.getAADToken(graphScopes, false) as Promise<string>;

    return token;
  }

  async getAADToken(
    oidcScopes: string[] = AppConfig.settings.oidcScopes,
    fullAuthResponse: boolean = false)
    : Promise<string | AuthenticationResult | null> {
    return lastValueFrom(this.cal.getAADToken(oidcScopes, false));
  }

  isUserLoggedIn(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
  }

  getUserInfo(): Observable<ICvxClaimsPrincipal> {
    return this.userSubject.asObservable();
  }

  public getFirstName() {
    return this.userSubject.pipe(map((user) => {
      if (user.name) {
        return user.name.split(',')[1].split('[')[0];
      }
      return '';
    }));
  }

  public async signIn(): Promise<boolean> {
    return lastValueFrom(this.cal.userInitiatedSignIn()).then(async data => {

      let name = data?.name ?? '';
      if (name) {
        let fullName = name.replace(/\s*\[.*\]/, '');
        fullName = fullName.replace(/\s*,\s*/, ' ');

        let names = fullName.trim().split(/\s+/);

        let firstName = names[1].charAt(0).toUpperCase() + names[1].slice(1).toLowerCase();
        let lastName = names[0].charAt(0).toUpperCase() + names[0].slice(1).toLowerCase();

        fullName = firstName + " " + lastName;
        sessionStorage.setItem('fullName', fullName);
      }
      if (!('accessToken' in sessionStorage)) {
        await this.getAADToken().then(async (x: any) => {
          sessionStorage.setItem('accessToken', x);
          await this.commonService.getRoleStatusData();
        });
      } else {
        await this.commonService.getRoleStatusData();
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (!data) {
        console.error('User failed to log in.');
      }

      let userIsActive = sessionStorage.getItem("userIsActive") ?? '';

      this.userSubject.next(data);
      let result = data != null && userIsActive == 'true';
      this.isLoggedInSubject.next(result);
      return result;
    });
  }
}
